module.exports = __webpack_public_path__ + "img/34.f017e947.jpg";